import React, { useState } from "react"
import { ResponsiveContext } from "grommet"
import { motion, AnimatePresence, useAnimation } from "framer-motion"
import { detect } from "detect-browser"

// Styles
import * as styles from "./SiteHeader.module.scss"

// Components
import Navigation from "./Navigation"
import Logo from "./Logo"
import NavigationVenue from "./NavigationVenue"
import HeaderStickers from "./HeaderStickers"
import siteContent from "../../content/siteContent"
import Hamburger from "./Hamburger"
import NavigationMobile from "./NavigationMobile"
import SearchPopover from "./SearchPopover"

const isIeBrowser = /(ie)/i.test(detect().name)

const SiteHeader = ({ currentLocation, venue, children }) => {
    const [mobileMenuVisible, setMobileMenuVisible] = useState(false)
    const [searchOpen, setSearchOpen] = useState(false)

    function handleClick(e) {
        setMobileMenuVisible(!mobileMenuVisible)
        e.preventDefault()
    }

    return (
        <div className={styles.SiteHeader}>
            <Logo venue={venue} />
            <HeaderStickers />

            <ResponsiveContext.Consumer>
                {(responsive) =>
                    responsive === "smallMobile" || responsive === "mobile" ? (
                        <>
                            <Hamburger isMobileMenuVisible={mobileMenuVisible} handleClick={handleClick} />
                            <NavigationMobile isMobileMenuVisible={mobileMenuVisible}>
                                <NavigationVenue venue={venue} />
                                <Navigation venue={venue} currentLocation={currentLocation} searchOpen={searchOpen} setSearchOpen={setSearchOpen} />
                            </NavigationMobile>
                        </>
                    ) : (
                        <>
                            <NavigationVenue venue={venue} />
                            <Navigation venue={venue} currentLocation={currentLocation} searchOpen={searchOpen} setSearchOpen={setSearchOpen} />
                        </>
                    )
                }
            </ResponsiveContext.Consumer>
            <AnimatePresence initial={false}>
                {searchOpen && (
                    <motion.div
                        className="motionDiv"
                        initial={{ opacity: isIeBrowser ? 1 : 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.4 }}
                    >
                        <SearchPopover closePopover={() => setSearchOpen(false)} />
                    </motion.div>
                )}
            </AnimatePresence>

            {children}
        </div>
    )
}

export default SiteHeader
